window.category =
{
    bindFilterForm: function (form)
    {
        var checkboxes = form.querySelectorAll("input[type=checkbox]");

        checkboxes.forEach(function (checkbox)
        {
            checkbox.addEventListener("change", async function (e)
            {
                await submitAjaxForm(form);

                price.asyncPrice();
            });
        });
    },
    initFilter: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (filterForm)
            category.bindFilterForm(filterForm);
    },
    updateParamUrl: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (!filterForm)
            return;

        var properties = [];

        var checkBoxes = filterForm.querySelectorAll(".form-check");

        checkBoxes.forEach(checkBox =>
        {
            var input = checkBox.querySelector("input[type=checkbox]");

            if (!input.checked)
                return;

            var propertyId = checkBox.querySelector("input[name$=PropertyId]").value;
            var valueId = checkBox.querySelector("input[name$=Value]").value;

            if (!properties[propertyId])
                properties[propertyId] = [];

            properties[propertyId].push(valueId);
        });

        var params = [];

        for (var propertyId in properties)
        {
            var values = properties[propertyId];
            var joinedValues = values.join(",");

            params.push(propertyId + "-" + joinedValues);
        }

        params = params.join(";");

        var parameters = new URLSearchParams(window.location.search);
        parameters.set("params", params);

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    }
};

document.addEventListener("DOMContentLoaded", function (e)
{
    category.initFilter();
});

//export default productFilter;